import AbstractLayuot from '../view/abstract-layout';

export const SELECT_VIEW = [
  [['layout', 'compact'], AbstractLayuot],
  [['layout', 'long'], AbstractLayuot],
  [['layout', 'growing'], AbstractLayuot],
  [AbstractLayuot]
];



// WEBPACK FOOTER //
// ./components/widget/settings/constants.js